import { render } from "./DpiStockView.vue?vue&type=template&id=5730eddc&ts=true"
import script from "./DpiStockView.vue?vue&type=script&lang=ts"
export * from "./DpiStockView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__